import gql from "graphql-tag";

export default gql`
  mutation DeleteAsset($id: ID!) {
    deleteAsset(id: $id) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/DeleteAsset.ts